import { css } from "theme/default/css";

export const setFlexDFJCSA = css`
  display: flex;
  justify-content: space-around;
`;
